import { createContext, useContext, useMemo, useState } from "react";
import type { ReactNode } from "react";

interface BaaNudgeOpenContextValue {
    open: boolean;
    setOpen: (open: boolean) => void;
}

const BaaNudgeOpenContext = createContext<BaaNudgeOpenContextValue>({
    open: false,
    setOpen: () => {},
});

// AIDEV-NOTE: The regulatory banner (layout header slot) and the eligibility dialog
// (protected-route) live in different trees; this is the one bit of shared state.
export function BaaNudgeOpenProvider({ children }: { children: ReactNode }) {
    const [open, setOpen] = useState(false);
    const value = useMemo(() => ({ open, setOpen }), [open]);
    return (
        <BaaNudgeOpenContext.Provider value={value}>
            {children}
        </BaaNudgeOpenContext.Provider>
    );
}

export function useBaaNudgeOpen() {
    return useContext(BaaNudgeOpenContext);
}
